import React from 'react';
import { useForm } from 'react-hook-form';

import { FormGroup } from '../components/FormGroup';
import { testLogin } from './devLogin';

/* Connexion par email + mot de passe des comptes de test (local et preprod uniquement, voir
   TEST_LOGIN_ENABLED). Sert aux tests Kuste de la pipeline, qui ne peuvent pas passer par Microsoft. */
export default function TestLoginForm() {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { email: '', password: '' } });

  const onSubmit = async ({ email, password }) => {
    const error = await testLogin(email, password);
    if (error) setError('root.server', { message: error });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="mt-[20px] pt-[16px] [border-top:1px_dashed_#e5e3de]"
    >
      <div className="text-[11px] font-semibold text-[#b45309] uppercase tracking-[.4px] mb-[8px]">
        Compte de test
      </div>
      <FormGroup label="Email">
        <input
          className="input"
          type="email"
          aria-label="Email du compte de test"
          autoComplete="username"
          {...register('email', { required: true })}
        />
      </FormGroup>
      <FormGroup label="Mot de passe">
        <input
          className="input"
          type="password"
          aria-label="Mot de passe du compte de test"
          autoComplete="current-password"
          {...register('password', { required: true })}
        />
      </FormGroup>
      {errors.root?.server && (
        <div className="text-[11px] text-[#dc2626] mb-[10px]">{errors.root.server.message}</div>
      )}
      <button
        type="submit"
        disabled={isSubmitting}
        className="btn btn-primary w-[100%] justify-center py-[8px] px-[12px]"
      >
        Se connecter avec le compte de test
      </button>
    </form>
  );
}
